//
// Recruitment Icon Morph
// --------------------------------------------------
// Uses GSAP MorphSVG to morph the goat icon into a cross icon for the recruitment dropdown

import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

gsap.registerPlugin(MorphSVGPlugin);

window.addEventListener('load', () => {
    console.log('MorphSVG Plugin loaded:', !!MorphSVGPlugin);

    const toggleCTA = document.getElementById('toggleCTA');
    const siteHeader = document.getElementById('siteHeader');

    if (!toggleCTA || !siteHeader) {
        console.log('Missing elements:', { toggleCTA: !!toggleCTA, siteHeader: !!siteHeader });
        return;
    }

    // Get the SVG path element inside the toggleCTA
    const svgPath = toggleCTA.querySelector('svg path');

    if (!svgPath) {
        console.log('No SVG path found in toggleCTA');
        return;
    }

    console.log('SVG path found, initializing morph...');

    // Store the original goat path
    const originalPath = svgPath.getAttribute('d');

    // Use the thick cross path that matches the goat's width and proportions
    const crossPath = "M450 150a40 40 0 0 0-56.57 0L257 286.43 120.57 150a40 40 0 1 0-56.57 56.57L200.43 343 64 479.43a40 40 0 0 0 56.57 56.57L257 399.57 393.43 536a40 40 0 1 0 56.57-56.57L313.57 343 450 206.57a40 40 0 0 0 0-56.57Z";

    let isOpen = false;

    // Function to morph to cross
    function morphToCross() {
        if (!isOpen) {
            console.log('Morphing to cross...', { crossPath, MorphSVGPlugin: !!MorphSVGPlugin });
            gsap.to(svgPath, {
                duration: 0.8,
                morphSVG: crossPath,
                ease: "power2.inOut",
                onComplete: () => console.log('Morph to cross complete')
            });
            isOpen = true;
        }
    }

    // Function to morph back to goat
    function morphToGoat() {
        if (isOpen) {
            console.log('Morphing to goat...', { originalPath });
            gsap.to(svgPath, {
                duration: 0.8,
                morphSVG: originalPath,
                ease: "power2.inOut",
                onComplete: () => console.log('Morph to goat complete')
            });
            isOpen = false;
        }
    }

    // Listen for recruitment dropdown state changes
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-recruitment') {
                const recruitmentState = siteHeader.getAttribute('data-recruitment');

                if (recruitmentState === 'true' && !isOpen) {
                    morphToCross();
                } else if (recruitmentState === 'false' && isOpen) {
                    morphToGoat();
                }
            }
        });
    });

    // Start observing the siteHeader for attribute changes
    observer.observe(siteHeader, {
        attributes: true,
        attributeFilter: ['data-recruitment']
    });

    // Expose functions globally for manual control if needed
    window.recruitmentIconMorph = {
        toCross: morphToCross,
        toGoat: morphToGoat,
        isOpen: () => isOpen
    };
});
